<!-- @format -->

@if (
	(shipMode$ | async) === 'sameDayDelivery' && sameDayDeliveryButtonText$ | async;
	as sameDayDeliveryButtonText
) {
	<div id="pdp-same-day-delivery-subtext">
		@if (
			(zipCode$ | async) !== 'null' &&
			(zipCode$ | async) &&
			sameDayDeliveryButtonText.fulfillmentLabelTextLine1
		) {
			<div
				id="pdp-same-day-delivery-line1"
				class="hmf-body-m hmf-body-m-l hmf-mb-xxs"
				[ngClass]="{
					'label-base-subtle': sameDayDeliveryButtonText.fulfillmentButtonDisabledClass,
					'label-base': !sameDayDeliveryButtonText.fulfillmentButtonDisabledClass
				}">
				{{ sameDayDeliveryButtonText.fulfillmentLabelTextLine1 }}
				<pdp-feature-change-zip-code-button
					[isSubtext]="true"
					[isDisabled]="sameDayDeliveryButtonText.fulfillmentButtonDisabledClass">
				</pdp-feature-change-zip-code-button>
			</div>
		}

		@if (sameDayDeliveryButtonText.lowStockMessage) {
			<div
				id="pdp-same-day-delivery-low-stock"
				class="hmf-mb-xxs hmf-body-bold-m label-warning">
				{{ sameDayDeliveryButtonText.lowStockMessage }}
			</div>
		}

		@if (sameDayDeliveryButtonText.sddAvailable) {
			<div
				id="pdp-same-day-delivery-fee"
				class="hmf-body-m hmf-mb-l label-base hmf-mb-m-xxs">
				$9.99 delivery fee.
				<button
					hmf-action-text
					class="details-link"
					dataEm="pdp-same-day-delivery"
					variant="tertiary"
					(click)="getSameDayDeliveryDetails()">
					Details
				</button>
			</div>
		}
	</div>
}

<ng-template #drawerContent>
	<div
		class="hmf-p-s hmf-p-md-m overflow-y-auto"
		[innerHTML]="sameDayDeliveryContent"></div>
</ng-template>
